import { QueryClient } from '@tanstack/react-query'

/**
 * Global QueryClient instance for TanStack Query
 * 
 * Configuration:
 * - staleTime: 2 minutes (120000ms) - data considered fresh for 2 min
 * - gcTime: 5 minutes (300000ms) - cache kept for 5 min after inactive
 * - refetchOnWindowFocus: false - don't refetch when tab regains focus
 * - retry: 2 - retry failed requests up to 2 times
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutes
      gcTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
      retry: 2,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      retry: 1,
    },
  },
})

/**
 * Devtools configuration for debugging
 * Only enabled in development
 */
export function getDevtoolsConfig() {
  if (process.env.NODE_ENV === 'development') {
    return {
      initialIsOpen: false,
      position: 'bottom-right' as const,
    }
  }
  return null
}
